import {
  ListItemIcon,
  ListItemText,
  MenuItem as MuiMenuItem,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";
import { useCallback, useMemo } from "react";
import { PageMenuItem } from "src/pi/application/Menu";
import app from "../../../../application/App";
import DynamicIcon from "../../DynamicIcon";

interface IProps {
  item: PageMenuItem;
  showIcon?: boolean;
}

const PageMenuItemComponent: React.FC<IProps> = observer((props) => {
  const { item, showIcon } = props;

  const appStore = useMemo(() => app(), []);

  const selectPage = useCallback(() => {
    appStore.selectPageAsync(item.page, {
      name: item.name,
      label: item.label,
    });
  }, [appStore, item]);

  const isSelected = !!appStore.page && item.page === appStore.page.name;

  return (
    <MuiMenuItem
      selected={isSelected}
      key={item.name}
      onClick={selectPage}
      disabled={!item.isEnabled}
    >
      {showIcon && (
        <ListItemIcon>
          <DynamicIcon icon={item.data.icon} color="inherit" />
        </ListItemIcon>
      )}
      <ListItemText primary={item.label} />
    </MuiMenuItem>
  );
});

export default PageMenuItemComponent;
